import axios from "axios";
import {NotificationType} from "@/api/notification";
import { JwtResponse, RoleEntity } from "@/api/auth";


export interface User {
  id: string | null;
  username: string;
  password?: string | null; //only for changing password
  email?: string | null;
  roles?: RoleEntity[];
  avatar?: string | null;
  avatarSmall?: string | null;
  emailSignature?: string | null;
  disabled?: boolean;
  phoneNumber?: string | null;
  userConfig?: UserConfig;
}

export function hasRole(user: JwtResponse, roleName: string): boolean {
  return (user.roles?.filter(role => role === roleName).length ?? 0) > 0 ?? false;
}

interface UserApi {
  list(): Promise<User[]>;
  getUserById(id: string): Promise<User>;
  add(user: User): Promise<string>;
  edit(id: string, user: User): Promise<void>;
  editOwn(id: string, user: User): Promise<void>;
  delete(id: string): Promise<void>;
  updateUserConfig(id: string, userConfig: UserConfig): Promise<void>;
  loadDefaultEmailSignature(): Promise<string>;
}

export interface UserConfig {
  favoritBlackboard: string | null;
  favoritProjectboard: string | null;
  signatureName?: string | null;
  signaturePhoneNumber?: string | null;
  visibleFutureTasks: boolean;
  maxTodosPerDay?: number;
  interestedInNotifications?: NotificationType[];
}

export const userApi: UserApi = {
  async list() {
    return (await axios.get("/api/users")).data;
  },

  async getUserById(id) {
    return (await axios.get(`/api/users/${id}`)).data;
  },

  async edit(id, user) {
    return await axios.put(`/api/users/${id}`, user);
  },

  async editOwn(id, user) {
    return await axios.put(`/api/users/own/${id}`, user);
  },

  async add(user) {
    return (await axios.post("/api/users", user)).data;
  },

  async delete(id) {
    return await axios.delete(`/api/users/${id}`);
  },

  async updateUserConfig(id, userConfig) {
    await axios.put(`/api/users/${id}/userConfig`, userConfig);
  },
  async loadDefaultEmailSignature() {
    return (await axios.get("/api/users/template/emailSignature")).data;
  },
};
